import routes from "modules/reportes/routes";

const commonProps = {
  activeClassName: "active",
};

export const links = routes.map((route) => ({ ...route, ...commonProps }));
